/*
 * Copyright (c) 2023-2024. Haodong JU
 */

import GlobalSettings from '@/model/global/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import StringEntity from '@/model/dataLayer/api/common/StringEntity'
import { defaultLanguage } from '@/model/global/DefaultLanguage'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    form: false,
    tableConfig: {
      align: 'start'
    },
    formConfig: {
      requiredNew: false
    }
  },
  _langsname: {
    form: false,
    displayName: 'name'
  },
  langs: {
    displayName: 'name',
    type: IKDataEntity.Types.Group,
    formConfig: {
      groupName: 'TaxRate', // 商品信息
      default: defaultLanguage(),
      childLabelKey: 'lang',
      type: {}
    },
    tableConfig: {
      displayCondition: (item) => {
        return item.lang.toLowerCase() === GlobalSettings.getLang().toLowerCase()
      },
      displayChild: (key) => {
        return key === 'name'
      }
    },
    childKey: ['name'],
    labelKey: 'lang',
    children: [StringEntity, StringEntity, StringEntity],
    header: false
  }
}
const config = {
  load: async function () {
    return (await hillo.get('CategoryType.php?op=getAllLangs', {
      lang: GlobalSettings.getLang()
    }))
      .content
  },
  edit: function (item) {
    item.langs = JSON.stringify(item.langs)
    return hillo.post('CategoryType.php?op=update', item)
  }
}

export default IKDataEntity.ModelFactory(entity, config)
